'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _FormButton = require('../../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GuestPopup = function GuestPopup(props) {
    return _react2.default.createElement(
        _PopupPanel2.default,
        _extends({ popupId: 'user' }, props),
        _react2.default.createElement(
            'p',
            { className: 'user-name' },
            'Guest user'
        ),
        _react2.default.createElement(
            _FormButton2.default,
            { className: 'primary', onClickFn: props.login },
            'Sign in'
        )
    );
};

GuestPopup.propTypes = {
    login: _propTypes2.default.func
};

exports.default = GuestPopup;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/AccountGuestPopup.js
// module id = 2167
// module chunks = 0